import React, { useState, useEffect, lazy, Suspense } from "react";
import Sidebar from "../../DesignSystem/Sidebar";
import ButtonFile from "../../DesignSystem/Buttons/ButtonFile";
import "../../../css/Finance/PdfToCsv/PdfToCsv.css";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../DesignSystem/Breadcrumb/Breadcrumb";

const PdfProcessor = lazy(() => import("./PdfProcessor"));

const FileUpload = () => {
  const [file, setFile] = useState(null);
  const [key, setKey] = useState(Date.now());
  const userPermissions =
    JSON.parse(localStorage.getItem("userPermissions")) || [];
  const navigate = useNavigate();

  useEffect(() => {
    if (!userPermissions.includes("Finance")) {
      navigate("/AdviserMap");
    }
  }, [userPermissions, navigate]);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setKey(Date.now());
    }
  };

  return (
    <div className="Main-Page">
      <Helmet>
        <title>Convert Commission Statements</title>
        <meta
          name="description"
          content="Upload a PDF file to convert it into a CSV format."
        />
      </Helmet>

      <Sidebar />

      <div className="Main-Container pdf-to-csv-page">
        <Breadcrumb
          items={[
            {
              label: "Finance",
              to: "/Department/Finance",
            },
            { label: "Convert Commission Statements" },
          ]}
        />
        <div className="Pdf-to-Csv-Container">
          <h2>Click to upload a SimplyBiz Statement</h2>

          {file && <div className="Content">{file.name}</div>}

          <div className="Pdf-to-Csv-Container-Buttons">
            <ButtonFile buttonText="Upload" onFileChange={handleFileChange} />

            {file && (
              <Suspense
                fallback={<div className="Content">Loading PDF tool...</div>}
              >
                <PdfProcessor key={key} file={file} />
              </Suspense>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileUpload;
